import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteReportedProduct = (
    backend: string,
    token: string,
    id: number,
) => {
    return fetch(
        `${getApiUrl(backend)}reported_products/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default deleteReportedProduct;
